/**
 * stepperProcessTab
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_stepper-process-tab.scss';

// Module template
import './_stepper-process-tab.twig';

export const name = 'stepperProcessTab';

export const defaults = {
  dummyClass: 'js-stepperProcessTab-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 */
export function enable($context) {
  // Find our component within the DOM
  const $stepperProcessTab = $('.stepper-process-tab', $context);
  // Bail if component does not exist
  if (!$stepperProcessTab.length) {
    return;
  }

  let activeTab;
  let dActiveTab;
  let accordionContainerHeader;
  let activeAccordion;

  $('.stepper-process-tab .tab_content').hide();
  // eslint-disable-next-line func-names
  $('.stepper-process-tab').each(function() {
    $(this)
      .find('.tab_content:first')
      .show();
  });

  /* if in tab mode */
  // eslint-disable-next-line func-names
  $('ul.tabs li').on('click', function() {
    $(this)
      .parent('ul.tabs')
      .attr('id');
    $(this)
      .parent()
      .parent()
      .find('.tab_content')
      .hide();
    accordionContainerHeader = `.${$(this)
      .parent('ul.tabs')
      .attr('id')}${$(this).index() + 1}`;
    $(accordionContainerHeader).trigger('click');
    activeTab = $(this).attr('rel');
    activeAccordion = $(this).attr('data-tab');
    // eslint-disable-next-line func-names
    $('.fm-accordion-item__header-link').each(function() {
      if ($(this).attr('aria-expanded') === 'true') {
        if (!$('.stepper-basic-tab', $context)) {
          $(this).trigger('click');
        }
      }
    });
    $(`#accordion-${activeAccordion}`)
      .find('.tabs-mobile-title')
      .trigger('click');
    $(`#${activeTab}`).show();
    $(this)
      .parent()
      .parent()
      .find('ul.tabs li')
      .removeClass('active');
    $(this).addClass('active');
    $(this)
      .parent()
      .parent()
      .find('.tab_drawer_heading')
      .removeClass('d_active');
    $(this)
      .parent()
      .parent()
      .find(`.tab_drawer_heading[rel^="${activeTab}"]`)
      .addClass('d_active');
  });

  /* if in drawer mode */
  // eslint-disable-next-line func-names
  $('.tab_drawer_heading').on('click', function() {
    $(this)
      .parent()
      .parent()
      .find('.tab_content')
      .hide();
    dActiveTab = $(this).attr('rel');
    $(`#${dActiveTab}`).fadeIn();
    $(this)
      .parent()
      .parent()
      .find('.tab_drawer_heading')
      .removeClass('d_active');
    $(this).addClass('d_active');
    $(this)
      .parent()
      .parent()
      .find('ul.tabs li')
      .removeClass('active');
    $(this)
      .parent()
      .parent()
      .find(`ul.tabs li[rel^="${dActiveTab}"]`)
      .addClass('active');
  });
  $('ul.tabs li')
    .last()
    .addClass('tab_last');

  // Grab all the parameters from URL.
  const searchParams = new URLSearchParams(window.location.search);
  // Check if URL has 'tab' parameter.
  if (searchParams.has('tab')) {
    // Grab value from tab parameter.
    const param = `#${searchParams.get('tab')}`;

    const stepperProcessTab = $(`.stepper-process-tab a[href="${param}"]`);
    const stepperBasicTab = $(`.stepper-basic-tab a[href="${param}"]`);

    if (stepperProcessTab.length) {
      // Assign tab link as class to Stepper Block container.
      $(`.stepper-process-tab`)
        .has(`a[href="${param}"]`)
        .addClass(`${searchParams.get('tab')}`);
      // Assign tab link as class to mobile Stepper Block container.
      $(`.stepper-process-tab-mobile`)
        .has(`a[href="${param}"]`)
        .addClass(`${searchParams.get('tab')}`);
      const tabClass = `.${searchParams.get('tab')}`;
      // Show tab link for mobile.
      if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        if (
          param !==
          $(`${tabClass} a`)
            .first()
            .attr('href')
        ) {
          $(`${tabClass} .tabs-mobile-title`)
            .first()
            .trigger('click');
          $(`${tabClass} a[href="${param}"] .tabs-mobile-title`).trigger(
            'click'
          );
        }
        $([document.documentElement, document.body]).animate(
          {
            // Open page on mobile stepper block container.
            scrollTop: $(`.stepper-process-tab-mobile${tabClass}`).offset().top,
          },
          1
        );
        // Show tab link for desktop.
      } else {
        // Show tab.
        $(`a[href="${param}"]`).trigger('click');
        $([document.documentElement, document.body]).animate(
          {
            // Open page on Desktop stepper block container.
            scrollTop: $(`${tabClass}`).offset().top,
          },
          1
        );
      }
    } else if (stepperBasicTab.length) {
      // Assign tab link as class to Stepper Block container.
      $(`.stepper-basic-tab`)
        .has(`a[href="${param}"]`)
        .addClass(`${searchParams.get('tab')}`);
      // Assign tab link as class to mobile Stepper Block container.
      $(`.stepper-basic-tab-mobile`)
        .has(`a[href="${param}"]`)
        .addClass(`${searchParams.get('tab')}`);
      // Show tab.
      $(`a[href="${param}"]`).trigger('click');
      const tabClass = `.${searchParams.get('tab')}`;
      // Show tab link for mobile.
      if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        if (
          param !==
          $(`${tabClass} a`)
            .first()
            .attr('href')
        ) {
          $(`${tabClass} .tabs-mobile-title`)
            .first()
            .trigger('click');
          $(`${tabClass} a[href="${param}"] .tabs-mobile-title`).trigger(
            'click'
          );
        }
        $([document.documentElement, document.body]).animate(
          {
            // Open page on mobile stepper block container.
            scrollTop: $(`.stepper-basic-tab-mobile${tabClass}`).offset().top,
          },
          1
        );
        // Show tab link for desktop.
      } else {
        $([document.documentElement, document.body]).animate(
          {
            // Open page on Desktop stepper block container.
            scrollTop: $(`${tabClass}`).offset().top,
          },
          1
        );
      }
    }
  }
}

export default enable;
